module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start-view"
  }, [_c('div', {
    staticClass: "logo"
  }, [(_vm.$i18n.locale == 'se') ? _c('img', {
    attrs: {
      "src": require("img/kunniakierros-logo-se.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("img/kunniakierros-logo-fi.png")
    }
  })]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "button button-green"
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t("startView.login")) + "\r\n            ")])])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('button', {
    staticClass: "button button-green"
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t("startView.about")) + "\r\n            ")])])], 1), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "sul-logo",
    attrs: {
      "src": require("img/sul-logo.svg")
    }
  }), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.$t("startView.footerText")) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "locale-chooser"
  }, [_c('a', {
    class: {
      disabled: _vm.$i18n.locale == 'fi'
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setLocale('fi')
      }
    }
  }, [_vm._v("Suomeksi")]), _vm._v(" "), _c('span', [_vm._v(" - ")]), _vm._v(" "), _c('a', {
    class: {
      disabled: _vm.$i18n.locale == 'se'
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setLocale('se')
      }
    }
  }, [_vm._v("På svenska")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a4b036","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/StartView.vue
// module id = 119
// module chunks = 0